import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import clsx from 'clsx';
import React from 'react';
import style from './block.module.scss';

const Inspector = React.lazy(() => import('./Inspector'));

const Button = ({
    icon,
    text,
    link,
    blank,
    aspect,
    backgroundContained,
    colorContained,
    position,
    classNames,
    hoverGreen = false,
    onClick = undefined,
    Wrapper = 'a',
    inspector = true,
    disableSubmit = false,
    isContentWidth = false,
    ...props
}) => {
    useInspectorControl(() => (inspector ? <Inspector active={inspector} /> : <></>));
    const { isEditing } = useEditor();

    return (
        <BlockWrapper.Div
            className={clsx(
                style.block,
                style[position],
                style[aspect],
                hoverGreen && style.hoverGreen,
                isContentWidth && style.contentWidth,
            )}
        >
            <Wrapper
                href={!isEditing ? link : undefined}
                target={blank ? '_blank' : undefined}
                onClick={onClick}
                className={clsx(style.button, aspect === 'contained' && 'button-myhand-medium', classNames)}
                style={{
                    color: aspect === 'contained' ? colorContained : null,
                    backgroundColor: aspect === 'contained' ? backgroundContained : 'transparent',
                }}
                disabled={disableSubmit}
                {...props}
            >
                {icon}
                {text}
            </Wrapper>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Button,
    smartProps: {
        text: smartProps.string.withDefault('Text du bouton'),
        link: smartProps.string.withDefault(''),
        blank: smartProps.bool.withDefault(false),
        aspect: smartProps.string.withDefault('contained'),
        position: smartProps.string.withDefault('left'),
        backgroundContained: smartProps.string.withDefault(''),
        colorContained: smartProps.string.withDefault(''),
        isContentWidth: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Bouton',
    },
});
